import React from 'react';
import classnames from 'classnames';
import styles from './index.module.scss';

const Bopomofo = ({ className, zhuyin = '', word = '' }) => {
  const isOnlyZhuyin = !word && zhuyin;

  return (
    <div className={classnames(styles.v, className)}>
      {
        isOnlyZhuyin ? (
          <>
          <rt>{zhuyin}</rt>
          </>
        ) : (
          <ruby>{word}<rt>{zhuyin}</rt></ruby>
        )
      }
    </div>
  )
};

export default Bopomofo;
